import {
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_TASK_BY_ID,
  GET_TASK_BY_ID_SUCCESS,
  GET_TASK_BY_ID_FAIL,
  POST_TASK_DOC_SUCCESS,
  POST_TASK_DOC_FAIL,
  GET_TASK_DOC_FAIL,
  GET_TASK_DOC_SUCCESS,
  POST_COMMENT_FAIL,
  POST_COMMENT_SUCCESS,
  UPDATE_COMMENT_FAIL,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT,
  UPDATE_ADMIN_COMMENT_FAIL,
  UPDATE_ADMIN_COMMENT_SUCCESS,
  CHANGE_TASK_STATUS_FAIL,
  CHANGE_TASK_STATUS_SUCCESS,
  EXPORT_TASK_DATA_FAIL,
  EXPORT_TASK_DATA_SUCCESS,
  UPDATE_STAFF_TIMMING_FAIL,
  UPDATE_STAFF_TIMMING_SUCCESS,
  UPDATE_TASK_DESCRIPTION_FAIL,
  UPDATE_TASK_DESCRIPTION_SUCCESS,
  INSERT_STAFF_TIMMING_FAIL,
  INSERT_STAFF_TIMMING_SUCCESS,
  DELETE_TASK_DESCRIPTION_FAIL,
  DELETE_TASK_DESCRIPTION_SUCCESS,
  DELETE_BULK_TASK_FAIL,
  DELETE_BULK_TASK_SUCCESS,
  SET_TASK_PAGE_SEARCH_RANGE,
  SET_CAL_PAGE_SEARCH_RANGE,
  EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL,
  EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS,
  CLOCK_IN_RESTRICTION_FAIL,
  CLOCK_IN_RESTRICTION_SUCCESS,
  GET_PARTICIPANT_LOCATIONS_FAIL,
  GET_PARTICIPANT_LOCATIONS_SUCCESS,
  DELETE_TASK_DOCS_SUCCESS,
  DELETE_TASK_DOCS_FAIL,
  TASK_LOGS_SUCCESS,
  TASK_LOGS_FAIL,
  TEAM_TASK_DETAIL_SUCCESS,
  TEAM_TASK_DETAIL_FAIL,
  TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS,
  TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL,
  TEAM_USER_TYPE,
  GET_EVENTS,
  RATE_TASK_SUCCESS,
  RATE_TASK_FAIL,
  SEND_RATE_TASK_EMAIL_SUCCESS,
  SEND_RATE_TASK_EMAIL_FAIL,
  GET_EVENTS_LIST_SUCCESS,
  GET_EVENTS_LIST_FAIL,
} from "./actionTypes";

import moment from "moment";
import { dateFormat } from "constants/TaskConstants";

const INIT_STATE = {
  events: [],
  eventDetail: [],
  categories: [],
  error: {},
  succRes: [],
  docs: [],
  res: [],
  clockInRes: [],
  vehiclRes: [],
  desc: [],
  admin_add_update_note_res: [],
  task_add_update_res: [],
  status_res: [],
  export_Data: [],
  locations: [],
  list: [],
  teamTaskDetail: [],
  teamUserType: "",
  loading: false,

  taskRange: {
    // state for range in task page
    from_date: moment().format(dateFormat),
    end_date: moment().add(15, "days").format(dateFormat),
  },
  calRange: {
    // state for range in calendar page
    from_date: moment().subtract(15, "days").format(dateFormat),
    end_date: moment().add(15, "days").format(dateFormat),
  },
};

const Calendar = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TEAM_USER_TYPE:
      return {
        ...state,
        teamUserType: action.payload,
      };
    case SET_TASK_PAGE_SEARCH_RANGE:
      return {
        ...state,
        taskRange: { ...state.taskRange, [action.payload.name]: action.payload.value },
      };
    case SET_CAL_PAGE_SEARCH_RANGE:
      return {
        ...state,
        calRange: { ...state.calRange, [action.payload.name]: action.payload.value },
      };
    case SEND_RATE_TASK_EMAIL_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case SEND_RATE_TASK_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case RATE_TASK_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case RATE_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_TASK_DOCS_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case DELETE_TASK_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_TASK_DETAIL_SUCCESS:
      return {
        ...state,
        teamTaskDetail: action.payload,
      };

    case TEAM_TASK_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TASK_LOGS_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };

    case TASK_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PARTICIPANT_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.payload,
      };

    case GET_PARTICIPANT_LOCATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS:
      return {
        ...state,
        vehiclRes: action.payload,
      };

    case EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_TASK_DESCRIPTION_SUCCESS:
      return {
        ...state,
        desc: action.payload,
      };

    case DELETE_TASK_DESCRIPTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_BULK_TASK_SUCCESS:
      return {
        ...state,
        task_add_update_res: action.payload,
      };

    case DELETE_BULK_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case INSERT_STAFF_TIMMING_SUCCESS:
      return {
        ...state,
        status_res: action.payload,
      };

    case INSERT_STAFF_TIMMING_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_TASK_DESCRIPTION_SUCCESS:
      return {
        ...state,
        desc: action.payload,
      };

    case UPDATE_TASK_DESCRIPTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_STAFF_TIMMING_SUCCESS:
      return {
        ...state,
        status_res: action.payload,
      };

    case UPDATE_STAFF_TIMMING_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EXPORT_TASK_DATA_SUCCESS:
      return {
        ...state,
        export_Data: action.payload,
      };

    case EXPORT_TASK_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CHANGE_TASK_STATUS_SUCCESS:
      return {
        ...state,
        status_res: action.payload,
      };

    case CHANGE_TASK_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_COMMENT:
      return {
        ...state,
      };
    case UPDATE_ADMIN_COMMENT_SUCCESS:
      return {
        ...state,
        admin_add_update_note_res: action.payload,
      };

    case UPDATE_ADMIN_COMMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case UPDATE_COMMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_COMMENT_SUCCESS:
      return {
        ...state,
        admin_add_update_note_res: action.payload,
      };

    case POST_COMMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_DOC_SUCCESS:
      return {
        ...state,
        docs: action.payload,
      };

    case GET_TASK_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case POST_TASK_DOC_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case CLOCK_IN_RESTRICTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case CLOCK_IN_RESTRICTION_SUCCESS:
      return {
        ...state,
        clockInRes: action.payload,
      };

    case POST_TASK_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_BY_ID:
      return {
        ...state,
        eventDetail: [],
        admin_add_update_note_res: [],
        docs: [],
      };
    case GET_TASK_BY_ID_SUCCESS:
      return {
        ...state,
        eventDetail: action.payload,
        clockInRes: [],
      };

    case GET_TASK_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_EVENTS:
      return {
        ...state,
        events: [],
        loading: true,
      };
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
        clockInRes: [],
        loading: false,
      };
    case GET_EVENTS_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
        loading: false,
      };
    case GET_EVENTS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        // events: [...state.events, action.payload],
        task_add_update_res: action.payload,
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        task_add_update_res: action.payload,
        // events: state.events.map(event =>
        //   event.id.toString() === action.payload.id.toString()
        //     ? { event, ...action.payload }
        //     : event
        // ),
      };

    case UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
        // events: state.events.filter(
        //   event => event.id.toString() !== action.payload.id.toString()
        // ),
      };

    case DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      };

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Calendar;
